import React from 'react';

export default function PrivacyPolicy({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-2xl p-6 rounded-2xl shadow-xl overflow-auto max-h-[80vh]">
        <h2 className="text-2xl font-bold mb-4">PRIVACY POLICY – CLINGFILM</h2>
        <p className="text-gray-700 text-sm mb-4">Last Updated: 9 September 2025</p>
        <div className="mb-4 text-gray-700 text-sm leading-relaxed space-y-3">
          <p>This Privacy Policy explains how Clingfilm (“the App”, “we”) collects, uses, and protects your personal data.</p>

          <h3 className="font-semibold mt-4">Data We Collect</h3>
          <ul className="list-disc list-inside">
            <li>Account details (e.g. name, email, profile info you provide).</li>
            <li>Content you add (e.g. reviews, ratings, watch history).</li>
            <li>Technical data (e.g. device type, IP address, usage statistics).</li>
            <li>We do not collect payment information directly (if paid features are added, payments will be handled by app stores or third-party processors).</li>
          </ul>

          <h3 className="font-semibold mt-4">How We Use Your Data</h3>
          <ul className="list-disc list-inside">
            <li>To provide and improve the App.</li>
            <li>To personalise recommendations.</li>
            <li>To communicate with you (e.g. updates, support).</li>
            <li>To maintain security and prevent misuse.</li>
          </ul>

          <h3 className="font-semibold mt-4">Legal Basis under GDPR</h3>
          <ul className="list-disc list-inside">
            <li>We process your data on the basis of:</li>
            <li>Consent (when you sign up, add reviews, or enable notifications).</li>
            <li>Legitimate interests (to improve services, prevent abuse).</li>
            <li>Legal obligations (where required).</li>
          </ul>

          <h3 className="font-semibold mt-4">Data Sharing</h3>
          <ul className="list-disc list-inside">
            <li>We do not sell your data.</li>
            <li>We may share data with trusted service providers (e.g. hosting, analytics, storage) under strict confidentiality.</li>
            <li>If required by law, we may disclose information to authorities.</li>
          </ul>

          <h3 className="font-semibold mt-4">Your Rights</h3>
          <p>Under GDPR, you have the right to:</p>
          <ul className="list-disc list-inside">
            <li>Access the data we hold about you.</li>
            <li>Request correction or deletion of your data.</li>
            <li>Restrict or object to processing.</li>
            <li>Request data portability.</li>
            <li>Withdraw consent at any time.</li>
          </ul>
          <p>To exercise your rights, contact <a href="mailto:angus@veipha.com" className="text-indigo-600 underline">angus@veipha.com</a>.</p>

          <h3 className="font-semibold mt-4">Data Storage &amp; Retention</h3>
          <p>Data is stored in secure cloud services (e.g. servers within the EU where possible).</p>
          <p>We keep your data only as long as necessary for the purposes stated above.</p>

          <h3 className="font-semibold mt-4">Security</h3>
          <p>We take reasonable technical and organisational measures to protect your data, but no system is 100% secure.</p>

          <h3 className="font-semibold mt-4">Changes</h3>
          <p>We may update this Privacy Policy. Significant changes will be notified within the App.</p>

          <p className="mt-6">Contact: <a href="mailto:angus@veipha.com" className="text-indigo-600 underline">angus@veipha.com</a></p>
        </div>
        <button
          className="brand-button text-lg px-8 py-3 mt-6"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
